import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { FormGroup, FormControl } from '@angular/forms';
import { ExtratoImportacaoService } from 'src/app/services/clique-retire/extrato-importacao/extrato-importacao.service';
import { Router } from '@angular/router';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Importacao, SelecionarExtratoImportacao } from 'src/app/@shared/models/extrato-importacao.model';
import { ModalExtratoImportacaoComponent } from './modal-extrato-importacao/modal-extrato-importacao.component';
import { ModalFalhaImportacaoComponent } from './modal-falha-importacao/modal-falha-importacao.component';

@Component({
  selector: 'app-extrato-importacao',
  templateUrl: './extrato-importacao.component.html',
  styleUrls: ['./extrato-importacao.component.scss']
})

export class ExtratoImportacaoComponent implements OnInit {
  isLoading = true;
  paging = { index: 0, size: 10, length: 0 };
  displayedColumns: string[] = [
    'criacao',
    'arquivo',
    'loteID',
    'statusImportacao',
    'totalFisico',
    'totalLogico',
    'status',
    'acao'
  ];
  imports: MatTableDataSource<Importacao> = new MatTableDataSource<Importacao>();

  filterForm = new FormGroup({
    fromDate: new FormControl(),
    toDate: new FormControl(),
  });

  get fromDate() { return this.filterForm.get('fromDate').value; }
  get toDate() { return this.filterForm.get('toDate').value; }

  constructor(
    public router: Router,
    public extratoImportacaoService: ExtratoImportacaoService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
    const filtroFim = new Date();
    const filtroInicio = new Date(filtroFim);
    filtroInicio.setDate(filtroInicio.getDate() - 10);
    this.filterForm.get('fromDate').setValue(filtroInicio);
    this.filterForm.get('toDate').setValue(filtroFim);

    this.selecionarExtratoImportacao();
  }

  clearFields() {
    this.filterForm.get('fromDate').setValue('');
    this.filterForm.get('toDate').setValue('');
    this.filterForm.updateValueAndValidity();
    this.selecionarExtratoImportacao();
  }

  selecionarExtratoImportacao() {
    this.isLoading = true;

    const obj = {
      dataInicio: this.fromDate ? this.fromDate.toISOString().split('T')[0] : null,
      dataFim: this.toDate ? this.toDate.toISOString().split('T')[0] : null,
      paginaAtual: this.paging.index + 1,
      itensPorPagina: this.paging.size
    };

    this.extratoImportacaoService.SelecionarExtratoImportacao(obj)
      .subscribe(
        (response: HttpResponse<Importacao[]>) => {
          this.imports.data = response.body;
          if (response.body.length > 0) {
            this.paging.length = response.body[0].totalCount;
          }
          this.isLoading = false;
        },
        (err: HttpErrorResponse) => {
          console.error(err);
          this.openSnackBar('Erro ao carregar Importações, entre em contato com o suporte : ' + err.error.Protocolo ?? err.error.Message, 'OK', 10000, 'warning-snackbar');
        });
  }

  onPageChange(evt: { pageIndex: number, pageSize: number }) {
    this.paging.index = evt.pageIndex;
    this.paging.size = evt.pageSize;
    this.selecionarExtratoImportacao();
  }

  openImportErrors(loteId) {
    const dialogRef = this.dialog.open(ModalFalhaImportacaoComponent, {
      disableClose: true,
      width: '540px',
      data: loteId
    });

    dialogRef.afterClosed().subscribe(
      response => {
        if (response !== 'cancel') { }
      }
    );
  }

  openImportDetails(loteId) {
    const dialogRef = this.dialog.open(ModalExtratoImportacaoComponent, {
      disableClose: true,
      width: '900px',
      data: loteId
    });

    dialogRef.afterClosed().subscribe(
      response => {
        if (response !== 'cancel') {
        }
      }
    );
  }

  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
